import React from "react";
import dayjs from "dayjs";
import colors from "common/styles/colors";
import { IconBadge } from "common/components/map/IconBadge";
import { HazardousObject } from "../../../types/api.types";
import {
  formatDistanceFromMeters,
  getHazardousObjectCaption,
  HazardousObjectTierLabels,
} from "../../../helpers/hazardousObjects.helpers";

interface HazardousObjectCardProps {
  hazardousObject: HazardousObject;
  objectNumber?: number;
}

const formatLastInspection = (lastInspection: string) => {
  const parsed = dayjs(lastInspection);
  return parsed.isValid() ? parsed.format("YYYY-MM-DD") : lastInspection;
};

export const HazardousObjectCard: React.FC<HazardousObjectCardProps> = ({
  hazardousObject,
  objectNumber,
}) => {
  const captionText = getHazardousObjectCaption(hazardousObject);
  const publicInfoUrls = hazardousObject.publicInfoUrls ?? [];

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        gap: "20px",
      }}
    >
      <div style={{ flex: 1 }}>
        <div
          style={{
            fontWeight: 500,
            fontSize: "14px",
            marginBottom: "5px",
            display: "flex",
            flexDirection: "row",
            gap: "8px",
          }}
        >
          {objectNumber !== undefined && <IconBadge count={objectNumber} />}
          {hazardousObject.name}
        </div>
        {!!captionText && (
          <div style={{ fontSize: "14px", color: colors.grey }}>
            {captionText}
          </div>
        )}
        <div
          style={{
            display: "inline-block",
            marginTop: "8px",
            padding: "2px 8px",
            borderRadius: "10px",
            backgroundColor: colors.greybg,
            color: colors.grey,
            fontSize: "12px",
          }}
        >
          {HazardousObjectTierLabels[hazardousObject.tier]}
        </div>
        {!!hazardousObject.lastInspection && (
          <div
            style={{ fontSize: "12px", color: colors.grey, marginTop: "5px" }}
          >
            Paskutinė patikra:{" "}
            {formatLastInspection(hazardousObject.lastInspection)}
          </div>
        )}
        {!!publicInfoUrls.length && (
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "10px",
              marginTop: "5px",
            }}
          >
            {publicInfoUrls.map((url, index) => (
              <a
                key={url}
                href={url}
                target="_blank"
                rel="noreferrer"
                style={{ fontSize: "12px", color: colors.purple2 }}
              >
                {publicInfoUrls.length > 1
                  ? `Vieša informacija (${index + 1})`
                  : "Vieša informacija"}
              </a>
            ))}
          </div>
        )}
      </div>
      <div style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
        {formatDistanceFromMeters(hazardousObject.distance)}
      </div>
    </div>
  );
};
